import React, { FunctionComponent, useRef, useEffect } from 'react'
import { Input } from 'antd'

// import { InputProps } from './InputProps'
import { SearchInputWrapper } from './styles'

//  eslint-disable-next-line @typescript-eslint/no-explicit-any
const SearchInput: FunctionComponent<any> = props => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (props.autoFocus && inputRef.current) {
      inputRef.current.focus()
    }
  }, [inputRef])

  return (
    <SearchInputWrapper>
      <Input ref={inputRef} {...props} autoComplete="off" />
    </SearchInputWrapper>
  )
}
export default SearchInput
